import { OrderedMap } from 'immutable';
import * as ActionTypes from '../../actions/ActionTypes';
import ArticlesRecord from '../../records/manage/ArticlesRecord';
import ArticleRecord from '../../records/ArticleRecord';
const ARTICLES = 'articles';
function getArticlesInfo(payload) {
  const {
    limit,
    objects,
    offset,
    total,
    totalCount
  } = payload;
  const articlesRecord = new ArticlesRecord({
    limit,
    offset,
    total,
    totalCount
  });
  return articlesRecord.set(ARTICLES, OrderedMap(objects.map(data => {
    const articleRecord = new ArticleRecord(data);
    return [articleRecord.values.hs_id, articleRecord];
  })));
}
function updateArticleVisibility(state, id, data) {
  return state.updateIn([ARTICLES, id], article => article && article.updateVisibility(data));
}
export default function articlesInfo(state = new ArticlesRecord(), action) {
  const {
    error,
    payload,
    type
  } = action;
  switch (type) {
    case ActionTypes.FETCH_ARTICLES_PENDING:
    case ActionTypes.DELETE_ARTICLE_PENDING:
    case ActionTypes.CLONE_ARTICLE_PENDING:
    case ActionTypes.DELETE_ARTICLES_BULK_PENDING:
    case ActionTypes.DELETE_ARTICLES_FILTERED_BULK_PENDING:
    case ActionTypes.ARCHIVE_ARTICLES_BULK_PENDING:
    case ActionTypes.ARCHIVE_ARTICLES_FILTERED_BULK_PENDING:
    case ActionTypes.ARCHIVE_ARTICLE_PENDING:
    case ActionTypes.UNARCHIVE_ARTICLE_PENDING:
    case ActionTypes.UNARCHIVE_ARTICLES_BULK_PENDING:
    case ActionTypes.UNARCHIVE_ARTICLES_FILTERED_BULK_PENDING:
    case ActionTypes.ARCHIVE_AND_UNPUBLISH_ARTICLE_PENDING:
    case ActionTypes.ARCHIVE_AND_UNPUBLISH_ARTICLES_BULK_PENDING:
    case ActionTypes.UNPUBLISH_ARTICLE_PENDING:
    case ActionTypes.UPDATE_ARTICLE_VISIBILITY_PENDING:
    case ActionTypes.UPDATE_ARTICLES_VISIBILITY_BULK_PENDING:
    case ActionTypes.UPDATE_ARTICLES_VISIBILITY_FILTERED_BULK_PENDING:
      return state.set('isRequesting', true);
    case ActionTypes.FETCH_ARTICLES_SUCCESS:
      return getArticlesInfo(payload).set('isRequesting', false);
    case ActionTypes.ARCHIVE_ARTICLES_BULK_SUCCESS:
    case ActionTypes.ARCHIVE_ARTICLES_FILTERED_BULK_SUCCESS:
    case ActionTypes.ARCHIVE_ARTICLE_SUCCESS:
    case ActionTypes.DELETE_ARTICLE_SUCCESS:
    case ActionTypes.CLONE_ARTICLE_SUCCESS:
    case ActionTypes.DELETE_ARTICLES_BULK_SUCCESS:
    case ActionTypes.DELETE_ARTICLES_FILTERED_BULK_SUCCESS:
    case ActionTypes.DETACH_FROM_LANGUAGE_GROUP_SUCCESS:
    case ActionTypes.UNARCHIVE_ARTICLE_SUCCESS:
    case ActionTypes.UNARCHIVE_ARTICLES_BULK_SUCCESS:
    case ActionTypes.UNARCHIVE_ARTICLES_FILTERED_BULK_SUCCESS:
    case ActionTypes.ARCHIVE_AND_UNPUBLISH_ARTICLE_SUCCESS:
    case ActionTypes.ARCHIVE_AND_UNPUBLISH_ARTICLES_BULK_SUCCESS:
    case ActionTypes.UNPUBLISH_ARTICLE_SUCCESS:
    case ActionTypes.UPDATE_ARTICLES_VISIBILITY_BULK_SUCCESS:
    case ActionTypes.UPDATE_ARTICLES_VISIBILITY_FILTERED_BULK_SUCCESS:
      return state.set('isRequesting', false);
    case ActionTypes.ARCHIVE_ARTICLES_BULK_ERROR:
    case ActionTypes.ARCHIVE_ARTICLES_FILTERED_BULK_ERROR:
    case ActionTypes.ARCHIVE_ARTICLE_ERROR:
    case ActionTypes.DELETE_ARTICLE_ERROR:
    case ActionTypes.CLONE_ARTICLE_ERROR:
    case ActionTypes.DELETE_ARTICLES_BULK_ERROR:
    case ActionTypes.DELETE_ARTICLES_FILTERED_BULK_ERROR:
    case ActionTypes.DETACH_FROM_LANGUAGE_GROUP_ERROR:
    case ActionTypes.FETCH_ARTICLES_ERROR:
    case ActionTypes.UNARCHIVE_ARTICLE_ERROR:
    case ActionTypes.UNARCHIVE_ARTICLES_BULK_ERROR:
    case ActionTypes.UNARCHIVE_ARTICLES_FILTERED_BULK_ERROR:
    case ActionTypes.ARCHIVE_AND_UNPUBLISH_ARTICLE_ERROR:
    case ActionTypes.ARCHIVE_AND_UNPUBLISH_ARTICLES_BULK_ERROR:
    case ActionTypes.UNPUBLISH_ARTICLE_ERROR:
    case ActionTypes.UPDATE_ARTICLE_VISIBILITY_ERROR:
    case ActionTypes.UPDATE_ARTICLES_VISIBILITY_BULK_ERROR:
    case ActionTypes.UPDATE_ARTICLES_VISIBILITY_FILTERED_BULK_ERROR:
      return state.merge({
        isRequesting: false,
        error
      });
    case ActionTypes.UPDATE_ARTICLE_VISIBILITY_SUCCESS:
      {
        if (state.hasIn([ARTICLES, payload.data.id])) {
          return updateArticleVisibility(state, payload.data.id, payload.data).set('isRequesting', false);
        }
        return state.set('isRequesting', false);
      }
    default:
      return state;
  }
}